import React, { useEffect } from "react";
import { useDrag } from "react-dnd";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { PropTypes } from "prop-types";
import { useTheme } from "@mui/material/styles";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  root: {
    cursor: "grab"
  },
  isDragging: {
    opacity: 0.4,
    cursor: "grabbing"
  },
  buttonText: {
    fontSize: "0.625rem",
    paddingTop: theme.spacing(0.25),
    textAlign: "center"
  }
}));

const DraggableItem = ({ icon, buttonText, buttonId, onIsDraggingChange }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: buttonId,
    item: { id: buttonId },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
      opacity: monitor.isDragging() ? 0.5 : 1
    })
  }));

  useEffect(() => {
    if (onIsDraggingChange) {
      onIsDraggingChange(isDragging);
    }
  }, [isDragging]);

  return (
    <div
      ref={dragRef}
      className={clsx(classes.root, {
        [classes.isDragging]: isDragging
      })}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        color={theme.palette.primary.main}
        p={0.5}
      >
        {icon}
        <Typography color="primary" className={classes.buttonText}>
          {buttonText}
        </Typography>
      </Box>
    </div>
  );
};

export default DraggableItem;

DraggableItem.propTypes = {
  /**
   * Called when the user presses the enter key on the search input box, clicks on one of the starting letter options,
   * or clicks on the "Filter List" button
   */
  onApplyFilters: PropTypes.func
};
